import { environment, SentryOptions } from '@core/const';

export const defaultTracesSampleRate = environment.production ? 0.1 : 1.0;
export const defaultSampleRate = environment.production ? 0.1 : 1.0;

export const config: SentryOptions = {
  dsn: environment.sentryDsn,
  sendDefaultPii: true,
  environment: environment.environment,
  release: environment.sentryRelease,
  maxBreadcrumbs: 20,
  tracesSampleRate: defaultTracesSampleRate,
  sampleRate: defaultSampleRate,
  tracePropagationTargets: [environment.apiBaseUrlCsr, environment.apiBaseUrlSsr],
};
